module.exports = __webpack_public_path__ + "static/MariageMirror-74c510797a10dfe07aac0c4cbac2fe68.jpg";